import { useState, useEffect } from "react";

const useViewportWidth = (): number => {
  const [width, setWidth] = useState<number>(typeof window !== "undefined" ? window.innerWidth : 1024); // Default width

  useEffect(() => {
    if (typeof window === "undefined") return; // Prevent running on server

    const handleResize = () => setWidth(window.innerWidth);
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

export default useViewportWidth;